module.exports = __webpack_public_path__ + "static/img/医疗卡片2_选中状态@2x.e31e62fe.png";